/* eslint-disable */
var icon = require('vue-svgicon');
icon.register({
    'file-earmark-diff': {
        width: 16,
        height: 16,
        viewBox: '0 0 16 16',
        data: '<path pid="0" d="M8 5a.5.5 0 01.5.5V7H10a.5.5 0 010 1H8.5v1.5a.5.5 0 01-1 0V8H6a.5.5 0 010-1h1.5V5.5A.5.5 0 018 5m-2.5 6.5A.5.5 0 016 11h4a.5.5 0 010 1H6a.5.5 0 01-.5-.5"/><path pid="1" d="M14 14V4.5L9.5 0H4a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2M9.5 3A1.5 1.5 0 0011 4.5h2V14a1 1 0 01-1 1H4a1 1 0 01-1-1V2a1 1 0 011-1h5.5z"/>',
    },
});
